
// ─────────────────────────────────────────────────────────────
// File: src/front/ts/nuclen-front-quiz.ts  (entry point)
// -----------------------------------------------------------------------------
import { initQuiz } from './nuclen-quiz-main';

/* Expose for lazy loader / global inline calls */
window.nuclearEngagementInitQuiz = initQuiz;
